import axios from "axios";
import React from "react";
import { GlobalError } from "../../../components/errors/GlobalError";
import { NavigateFunction } from "react-router-dom";
import { autoLogin } from "Helper/AutoLoginHelper";
import { Dispatch } from "redux";
import { GetApplication, GetApplicationVersion } from "utilityFunctions";

interface SimpleClientRegisterRequestI {
  application: string;
  applicationVersion: string;
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  language: string;
  promotionCode?: string;
  qrTokenToValidate?: string;
  referrerEmail?: string;
}

export const SimpleClientRegister =
  (
    firstName: string,
    lastName: string,
    email: string,
    password: string,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setEmailInUseError: React.Dispatch<React.SetStateAction<boolean>>,
    setForbiddenError: React.Dispatch<React.SetStateAction<boolean>>,
    setSignInRedirect: React.Dispatch<React.SetStateAction<boolean>>,
    navigate: NavigateFunction,
    dispatch: Dispatch,
    language: string,
    screenWidth: number,
    qrTokenToValidate?: string,
    referrerEmail?: string
  ) =>
  async () => {
    setLoading(true);
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const promotionCode = localStorage.getItem("promoCode");

    const simpleClientRegisterRequest: SimpleClientRegisterRequestI = {
      application: await GetApplication(),
      applicationVersion: GetApplicationVersion(),
      email,
      firstName,
      lastName,
      password,
      language,
      qrTokenToValidate: qrTokenToValidate,
      referrerEmail,
      promotionCode: !!promotionCode ? promotionCode : undefined,
    };

    try {
      const simpleClientRegisterResponse = await axios.post(
        `${BASE_URL}/api/users/register`,
        simpleClientRegisterRequest,
        {
          headers: {
            "Accept-Language": language === "en" ? "en-US;" : "fr-CA;",
          },
        }
      );
      if (simpleClientRegisterResponse.status === 200) {
        sessionStorage.removeItem("demoAddress");
        if (promotionCode) {
          localStorage.removeItem("promoCode");
        }
        setLoading(false);
        if (!!qrTokenToValidate) {
          return navigate("/done", {
            state: { email, password, qrTokenToValidate },
          });
        }
        if (screenWidth <= 640) {
          return navigate("/confirmation", { state: { email, password } });
        }
        if (screenWidth > 640) {
          autoLogin(
            email,
            password,
            undefined,
            language,
            dispatch,
            setSignInRedirect
          );
        }
      }
    } catch (error: any) {
      if (error.response?.status === 409) {
        setLoading(false);
        return setEmailInUseError(true);
      } else if (error.response.status === 403) {
        setLoading(false);
        return setForbiddenError(true);
      } else {
        console.log("here are the error details", error.response);
        setLoading(false);
        GlobalError(error);
      }
    }
  };
